import {Record, Map} from "immutable"

interface Properties {
    id: number
    year: number
    title: string
    demand: number
    hiPo: number
    hiPoType: string
    hiPoTypeName: string
    countryId: string
    countryName: string
    notes: string
}

export class Vacancy extends Record({
    id: undefined,
    year: undefined,
    title: undefined,
    demand: undefined,
    hiPo: undefined,
    hiPoType: undefined,
    hiPoTypeName: undefined,
    countryId: undefined,
    countryName: undefined,
    notes: undefined,
}) implements Properties {
    readonly id: number
    readonly year: number
    readonly title: string
    readonly demand: number
    readonly hiPo: number
    readonly hiPoType: string
    readonly hiPoTypeName: string
    readonly countryId: string
    readonly countryName: string
    readonly notes: string

    constructor(values: Properties) {
        super(values)
    }
}

export type JsonData =  {
    id: number
    year: number
    title: string
    demand: number
    hiPo: number
    hiPoType: string
    hiPoTypeName: string
    countryId: string
    countryName: string
    notes: string
}

export const fromJs = ({
    id,
    year,
    title,
    demand,
    hiPo,
    hiPoType,
    hiPoTypeName,
    countryId,
    countryName,
    notes,
}: JsonData): Vacancy => new Vacancy({
    id,
    year,
    title,
    demand,
    hiPo,
    hiPoType,
    hiPoTypeName,
    countryId,
    countryName,
    notes,
})

export type Vacancies = Map<number, Vacancy>